import React from "react";

import { AsyncJobDownloadComponent } from "../../../../../../hooks/useAsyncJobDownload";

import BasePageTemplate from "../../../../../../pageTemplates/BasePageTemplate";
import { SurveyResultsHeader, SurveyResultsKPIs, SurveyResultsTable } from "./sections";

export function SurveyResults({ surveyId }: { surveyId: string }) {
	return (
		<BasePageTemplate title="Survey Results">
			<AsyncJobDownloadComponent jobName="survey-results-csv-export" />
			<div className="flex flex-col gap-6">
				{/* Header */}
				<SurveyResultsHeader surveyId={surveyId} />
				{/* KPIs */}
				<SurveyResultsKPIs surveyId={surveyId} />
				<div className="h-[1px] w-full bg-neutral-2" />
				{/* Results Table */}
				<SurveyResultsTable surveyId={surveyId} />
			</div>
		</BasePageTemplate>
	);
}
